<template>
  <base-container ref="container" :isLoading="loading">
    <artisan-group style="height: 50%" title="相同项目之间的合并规则" class="border-bottom-gray">
      <el-row style="height: 100%">
        <el-col :span="8" style="height: 100%">
          <el-row>
            <el-col class="padding3" :span="8" v-for="item in projects" :key="item.id">
              <!-- <el-button
                style="width: 100%"
                type="primary"
                :plain="projectId != item.id"
                @click="checkProject(item)"
              >
                {{ item.name }}
              </el-button> -->

              <el-tooltip :content="item.name" placement="top-start">

                <el-button class="home-attachment-name" style="width: 100%" type="primary" :plain="projectId != item.id"
                  @click="checkProject(item)">
                  {{ item.name }}
                </el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="14" style="height: 100%">
          <artisan-group style="height: 100%" class="border-gray" title="部位合并优先级">
            <template #header>
              <el-row type="flex" justify="space-between" align="middle">
                <span>部位合并优先级</span>
                <div>
                  <el-button type="primary" size="mini" icon="el-icon-plus" :disabled="!projectId" plain circle
                    @click="addMergeParts"></el-button>
                  <el-button :disabled="!projectId" type="success" size="mini" icon="el-icon-check" plain circle
                    @click="saveMergeParts"></el-button>
                </div>
              </el-row>
            </template>
            <draggable :animation="340" :list="partRules" handle=".movable">
              <el-row type="flex" justify="space-between" align="middle"
                class="margin-v5 padding5 movable color-white back-success" v-for="(item, index) in partRules"
                :key="index">
                <el-input size="mini" placeholder="请输入内容" v-model="item.parts">
                  <template slot="prepend">{{ index + 1 }}</template>
                </el-input>
                <el-button type="danger" size="mini" icon="el-icon-delete" plain circle
                  @click="removeMergeParts(index)"></el-button>
              </el-row>
            </draggable>
          </artisan-group>
        </el-col>
      </el-row>
    </artisan-group>
    <artisan-group style="height: 50%" title="不同项目之间的合并规则">
      <el-row>
        <el-col :span="8" style="padding: 5px" v-for="(item, index) in rules" :key="item.id">
          <el-row class="back-success color-white" style="border-radius: 10px; padding: 5px" type="flex"
            justify="space-around" align="middle">
            <div class="align-center">
              {{ item.projectName }}({{ item.projectId }})
            </div>
            <div class="align-center margin-h5 margin-v10">
              合并
              <div>
                <img style="height: 10px; width: 60px" src="/img/rule/repel.png" />
              </div>
            </div>
            <div class="align-center">
              {{ item.relateProjectName }}({{ item.relateProjectId }})
            </div>
            <el-button circle size="mini" type="danger" plain icon="el-icon-delete" @click="remove(item, index)">
            </el-button>
          </el-row>
        </el-col>
        <el-col style="padding: 5px" :span="8">
          <el-button type="success" plain icon="el-icon-plus" style="
              height: 72px;
              text-align: center;
              width: 100%;
              border-radius: 10px;
            " @click="addRule">
            新增合并规则
          </el-button>
        </el-col>
      </el-row>
    </artisan-group>
    <artisan-dialog height="150px" width="660px" :visible.sync="show" title="新增合并规则" :isLoading="dialogLoading">
      <el-row type="flex" class="margin-h5" justify="space-around" align="middle">
        <div>
          <div class="align-center">项目</div>
          <el-select filterable clearable v-model="rule.projectId" size="mini">
            <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="margin-h5 align-center">
          合并
          <div>
            <img style="height: 10px; width: 100px" src="/img/rule/interval.png" />
          </div>
        </div>
        <div>
          <div class="align-center">项目</div>
          <el-select filterable clearable v-model="rule.relateProjectId" size="mini">
            <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </el-row>
      <template #footer>
        <el-button class="margin-h5" size="mini" type="primary" icon="el-icon-plus" @click="confirmRule">
          确认保存
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import prop from "./prop.js";
import draggable from "vuedraggable";
import { add, remove } from "@/api/jc/clinical-rule";
import { saveMergeParts } from "@/api/jc/project";
export default {
  components: { draggable },
  mixins: [prop],
  data() {
    return {
      rule: {
        code: "merge",
        projectId: "",
        projectName: "",
        relateProjectId: "",
        relateProjectName: "",
      },
      show: false,
      loading: false,
      dialogLoading: false,
      projectId: "",
      partRules: [],
    };
  },
  watch: {
    projectId() {
      let item = this.projects.find((c) => c.id == this.projectId);
      if (item) {
        let parts = item.mergeParts ? item.mergeParts.split(",") : [];
        this.partRules = parts.map((c) => {
          return { parts: c };
        });
      } else {
        this.partRules = [];
      }
    },
  },
  created() {
    if (this.projects.length > 0) {
      this.checkProject(this.projects[0]);
    }
  },
  methods: {
    checkProject(item) {
      this.projectId = item.id;
    },
    addMergeParts() {
      this.partRules.push({ parts: "" });
    },
    removeMergeParts(i) {
      this.partRules.splice(i, 1);
    },
    saveMergeParts() {
      this.loading = true;
      let data = {};
      if (this.projectId) {
        data.id = this.projectId;
        data.mergeParts = this.partRules.map((c) => c.parts).join(",");
        saveMergeParts(data)
          .then((res) => {
            this.$message({ type: "success", message: "保存成功！" });
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    addRule() {
      this.rule = {
        code: "merge",
        projectId: "",
        projectName: "",
        relateProjectId: "",
        relateProjectName: "",
        duration: "1",
      };
      this.show = true;
    },
    confirmRule() {
      if (this.rule.projectId && this.rule.relateProjectId) {
        let rule = this.rules.find(
          (c) =>
            (c.projectId == this.rule.projectId &&
              c.relateProjectId == this.rule.relateProjectId) ||
            (c.projectId == this.rule.relateProjectId &&
              c.relateProjectId == this.rule.projectId)
        );
        if (rule) {
          this.$message({
            type: "warning",
            message: "已存在两个项目的合并规则!",
          });
          return;
        }
        this.rule.id = "";
        let project = this.projects.find((c) => c.id == this.rule.projectId);
        this.rule.projectName = project.name;
        project = this.projects.find((c) => c.id == this.rule.relateProjectId);
        this.rule.relateProjectName = project.name;
        this.dialogLoading = true;
        add(this.rule)
          .then(() => {
            this.dialogLoading = false;
            this.show = false;
            this.loadRules();
          })
          .catch(() => {
            this.dialogLoading = false;
          });
      } else {
        this.$message({ type: "warning", message: "请输入必要的参数！" });
        return;
      }
    },
    remove(rule, index) {
      this.$refs.container.confirm({ msg: "确认删除？" }).then((res) => {
        this.loading = true;
        remove(rule.id)
          .then(() => {
            this.loading = false;
            this.loadRules();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style>
.home-attachment-name {
  width: 330px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
